import { useMemo } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  BookOutlined,
  AppstoreOutlined,
  MessageOutlined,
  CrownOutlined,
  ShopOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { ENABLE_PROTOTYPE } from "./featureFlags";
import "./styles/PlaybookShell.css";

const APPS = [
  {
    key: "super-admin",
    title: "Ziniz Super Admin",
    icon: <CrownOutlined />,
    wizardPath: "/super-admin/wizard",
    prototypePath: "/super-admin/prototype",
  },
  {
    key: "zinihub-admin",
    title: "ZiniHub Admin",
    icon: <AppstoreOutlined />,
    wizardPath: "/zinihub-admin/wizard",
    prototypePath: "/zinihub-admin/prototype",
  },
  {
    key: "zinihub-cust",
    title: "ZiniHub Customer",
    icon: <ShopOutlined />,
    wizardPath: "/zinihub-cust/wizard",
    prototypePath: "/zinihub-cust/prototype",
  },
  {
    key: "zibuzz",
    title: "ZiBuzz",
    icon: <MessageOutlined />,
    wizardPath: "/zibuzz/wizard",
    prototypePath: "/zibuzz/prototype",
  },
  {
    key: "zinipixels",
    title: "ZiniPixels",
    icon: <EditOutlined />,
    wizardPath: "/zinipixels/wizard",
    prototypePath: "/zinipixels/prototype",
  },
  { key: "brand-book", title: "Brand Book", icon: <BookOutlined />, path: "/brand-book" },
];

function resolveActiveAppKey(pathname) {
  if (pathname.startsWith("/zinihub-admin") || pathname.startsWith("/zinihub/wizard") || pathname.startsWith("/zinihub/prototype")) {
    return "zinihub-admin";
  }
  if (pathname.startsWith("/zinihub-cust")) return "zinihub-cust";
  if (pathname.startsWith("/zibuzz")) return "zibuzz";
  if (pathname.startsWith("/zinipixels")) return "zinipixels";
  if (pathname.startsWith("/super-admin")) return "super-admin";
  if (pathname.startsWith("/brand-book")) return "brand-book";
  return "super-admin";
}

function resolveArtifactMode(pathname) {
  if (pathname.endsWith("/prototype")) return "prototype";
  if (pathname.endsWith("/wizard")) return "wizard";
  return null;
}

export default function PlaybookShell() {
  const navigate = useNavigate();
  const location = useLocation();
  const activeAppKey = resolveActiveAppKey(location.pathname);
  const artifactMode = resolveArtifactMode(location.pathname);
  const activeApp = useMemo(
    () => APPS.find((app) => app.key === activeAppKey) || APPS[0],
    [activeAppKey]
  );
  const hasArtifactTabs = ENABLE_PROTOTYPE && Boolean(activeApp.wizardPath && activeApp.prototypePath);

  return (
    <div className="playbook-layout">
      <header className="playbook-topbar">
        <div className="playbook-topbar-logo" onClick={() => navigate("/brand-book")} role="button" tabIndex={0}>
          ZiniPlaybook
        </div>
        <nav className="playbook-topbar-apps" aria-label="Products">
          {APPS.map((app) => {
            const selected = activeAppKey === app.key;
            return (
              <button
                key={app.key}
                type="button"
                className={`playbook-topbar-app${selected ? " playbook-topbar-app--active" : ""}`}
                onClick={() => navigate(app.path || app.wizardPath)}
              >
                <span className="playbook-topbar-app-icon">{app.icon}</span>
                <span>{app.title}</span>
              </button>
            );
          })}
        </nav>
        {hasArtifactTabs && (
          <div className="playbook-topbar-artifacts" aria-label="Artifact">
            <button
              type="button"
              className={`playbook-topbar-artifact${artifactMode === "wizard" ? " playbook-topbar-artifact--active" : ""}`}
              onClick={() => navigate(activeApp.wizardPath)}
            >
              UX Wizard
            </button>
            <button
              type="button"
              className={`playbook-topbar-artifact${artifactMode === "prototype" ? " playbook-topbar-artifact--active" : ""}`}
              onClick={() => navigate(activeApp.prototypePath)}
            >
              Prototype
            </button>
          </div>
        )}
      </header>
      <main className="playbook-content">
        <Outlet />
      </main>
    </div>
  );
}
